.buttons {
  display: flex;
  flex-direction: column;
  // gap: 10px;
  // justify-content: center;

  // & > button {
  //   padding: 10px 0;
  // }
  button:first-of-type {
    margin-top: 0!important;
  }
  button {
    border-radius: 16px;
    height: 36px;
  }
}
